import React from "react";
export default () => (
  <div className="row">
    <div className="col-lg-4">
      <h2>About</h2>
      <h3>What I am all about.</h3>
    </div>
    <div className="col-lg-8">
      <p>Hi there, and thanks for visiting my site!</p>
      <p>
        I'm Keith, a coding enthusiast who thrives on challenges. Present me
        with a problem, and I'll be engrossed in solving it with excellence. I
        relish a good challenge and firmly believe that the key to finding and
        coding the most effective solutions lies in dedicated teamwork.
      </p>
      <p>
        My journey began with three years of university, laying a solid
        foundation in software development. However, it was in the professional
        world where I truly blossomed, connecting the dots to understand what it
        takes to be an exceptional developer.
      </p>
      <p>
        As an advocate for clean code and architecture, I stand by the principle
        that code should be simple, elegant, and easily maintainable. Every line
        of code I write is preceded by careful thought and planning.
      </p>
      <p>
        Approaching every project with an open mind is crucial. I value
        collaborative team discussions to brainstorm and converge on the most
        suitable solutions, ensuring adherence to best practices.
      </p>
      <p>
        And when it comes to testing? Well, let's just say I aim for 100% test
        coverage - always striving to ensure reliability and quality!
      </p>
      <p>Happy coding!</p>
    </div>
  </div>
);
